<template>
  <transition name="fade" mode="out-in">
    <div class="contact-page-container">
      <nav-component :isDarkBg="true"></nav-component>
      <div class="contact-hero main">
        <h2>Let's Connect</h2>
      </div>
      <div class="contact-form-container">
        <div class="contact-info">
          <h2>Toronto Headquarters</h2>
          <div class="address">
            <p class="charcoal">60 Columbia Way, 9th&nbsp;Floor<br>
            Markham, Ontario<br>
            Canada L3R 0C9<br>
            <a href="https://goo.gl/maps/mqa3a424LbNpdtik6" target="_blank"><span class="orange">>View Map</span></a></p>
            
            <p class="charcoal"><strong class="charcoal">General</strong><br>
            <a href="mailto:info@globalrewardsolutions.com">info@globalrewardsolutions.com</a></p>
            
            <p class="charcoal"><strong class="charcoal">Need customer support?</strong><br><br>
            Get fast, personalized help by logging into your program and placing a customer support ticket.</p>
            </p>
          </div>
          <!-- <h2>Connect With Us</h2> -->
          <div class="socials">
            <a href="https://www.facebook.com/Global-Reward-Solutions-1859166251009345/" target="_blank">
              <img src="@/assets/img/facebook-contact.png" alt="">
            </a>
            <a href="https://twitter.com/grs_rewards" target="_blank" rel="nofollow">
              <img src="@/assets/img/x-contact.png" alt="">
            </a>
            <a href="https://ca.linkedin.com/company/globalrewardsolutions" target="_blank" rel="nofollow">
              <img src="@/assets/img/linkedin-contact.png" alt="">
            </a>
          </div>
        </div>
        <div class="contact-form">
          <p class="learn-more-heading charcoal">Learn more about Global Reward Solutions</p>
          <p class="charcoal">Want to discover which of our solutions can help grow your business? Want to join our supplier network? Simply complete this form and we will be in touch.</p>

          <div id="hubspotForm"></div>
          
        </div>
      </div>
      <footer-component></footer-component>
    </div>
  </transition>
</template>

<script>
  export default {
    data: function () {
      return {
        name: 'contact'
      }
    },
    mounted () {
      const script = document.createElement("script");
      script.src="https://js.hsforms.net/forms/v2.js";
      document.body.appendChild(script);

      script.addEventListener("load", () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            region: "na1",
            portalId: "9304889",
            formId: "a90006be-064a-43f9-be3f-e48e4b9467b4",
            target: "#hubspotForm"
          })
        }
      })
    }
  }
</script>

<style lang="scss">

  /*HEADER/HERO*/
  .contact-hero {
    background-image: url(../assets/img/contact-hero.jpg);
    background-position: center;
    -webkit-background-size: contain;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 80px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .contact-hero.main h2 {
    color: #FFF;
    text-align: center;
    font-size: 48px;
    font-weight: 700 !important;
    line-height: 52px;
    margin: 40px 0;
    padding: 0;
    letter-spacing: normal !important;
  }

  /*CONTACT FORM*/
  .contact-form-container {
    width: 90% !important;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    padding: 60px 0;
    flex-direction: row;
    color: #343333 !important;
  }
  .contact-form-container p {
    color: #343333 !important;
    line-height: 28px;
  }

  .contact-info {
    width: 40%;
    padding-right: 20px !important;
  }
  .contact-info .address p a {
    color: inherit;
    transition: all 0.125s linear;
    display: block;
    padding-top: 15px;
  }
  .contact-info .address p a:hover { color: #00B1FF; }
  .contact-info h2 {
    font-size: 24px !important;
    margin-bottom: 20px;
    line-height: 24px !important;
  }

  span.orange {
    color: #00A4FF !important;
    cursor: pointer;
  }

  .socials img {
    max-width: 35px;
    padding-right: 10px;
  }

  /*NEW HUBSPOT*/
  
  ::-webkit-input-placeholder { opacity: 1; }
  ::-moz-placeholder { opacity: 1; }

  p.learn-more-heading {
    font-size: 28px !important;
    font-weight: bold;
    margin: 0;
  }

  .contact-form {
    width: 60%;
    display: flex;
    flex-direction: column;

    #hubspotForm { margin-top: 30px; }

    form { width: 100% !important; }

    fieldset { max-width: unset !important; }
  }

  .hs-form-field {
    position: relative;
    margin-bottom: 30px;

    .hs-input {
      width: 100% !important;
      background-color: #fff;
    }

    input {
      width: 100%;
      box-sizing: border-box;
      
      &.hs-input.invalid.error { border: 1px solid #FD0000 !important; }
    }
        
    .hs-error-msgs {
      padding: 0 0 0 10px;
      margin: 0;
      list-style: none;
      position: absolute;
      top: 50px;
      
      li { 
        font-size: 12px;

        .hs-error-msg { color: #FD0000; }
      }
    }
  }

  .hs_error_rollup ul {
    margin: 0 0 20px 0;
    padding: 0 0 0 10px;
    list-style: none;

    li label { color: #FD0000; }
  }

  .contact-form input,
  .contact-form textarea {
    border: 1px solid #D4D9E2;
    border-radius: 3px;
    padding: 15px;
    font-size: 14px;
    color: #596377;
    outline: 0;
    transition: all 0.2s linear;
  }
  
  .contact-form input:focus,
  .contact-form textarea:focus {
    border: 1px solid #000;
  }
  .contact-form textarea {
    min-height: 200px;
    resize: none;
    width: 100%;
    box-sizing: border-box;
  }

  .contact-form select {
    background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
    background-position: calc(100% - 20px) calc(1em + 8px), calc(100% - 15px) calc(1em + 8px), calc(100% - 2.5em) 1em;
    background-size: 5px 5px, 5px 5px, 1px 1.5em;
    background-repeat: no-repeat;
    -webkit-appearance: none;
    height: 50px !important;
    border: 1px solid #D4D9E2;
    border-radius: 3px;
    padding: 15px;
    font-size: 14px;
    color: #596377 !important;
    outline: 0;
  }

  #hsForm_a90006be-064a-43f9-be3f-e48e4b9467b4 select option,
  .contact-form select option { color: #596377 !important; }

  .hs-button.primary.large {
    width: fit-content;
    width: -moz-fit-content;
    text-align: center;
    color: #fff;
    background-color: #00A4FF !important;
    background-image: none !important;
    padding: 10px 20px 8px !important;
    font-size: 18px !important;
    transition: 0.25s;
    border: 2px solid #00A4FF !important;
    position: relative;
    border-radius: 52px !important;
    margin: 0;
    cursor: pointer;
    text-transform: uppercase;
    font-family: mr-eaves-xl-modern, sans-serif;

    &:hover {
      background-color: #fff !important;
      color: #00A4FF !important;
    }
  }

  #hsForm_a90006be-064a-43f9-be3f-e48e4b9467b4 .input ul li.hs-form-checkbox span,
  #hsForm_a90006be-064a-43f9-be3f-e48e4b9467b4 .hs-fieldtype-checkbox span,
  #hsForm_a90006be-064a-43f9-be3f-e48e4b9467b4 .hs-fieldtype-text span { color: #343333 !important; }

  /*OFFICE LOCATIONS/ADDRESSES*/
  .our-offices {
    width: 100%;
    padding: 60px 0;
    background-color: #eeeeee;
    text-align: center;
  }

  .addresses {
    width: 80%;
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .address {
    text-align: left;
    width: 65%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-bottom: 20px;
  }
  .address h3 {
    font-size: 20px;
    font-weight: 200;
    color: #636466;
    margin: 0 0 4px 0;
  }
  .address p {
    margin-top: 8px;
    line-height: 24px;
  }

  @-moz-document url-prefix() { 
    .contact-hero h2 { font-weight: 700 !important; }
  }

  @media (max-width: 992px) {
    .contact-form-container { flex-direction: column !important; }

    .contact-page-container .our-offices h2 { font-size: 40px; }

    .contact-info {
      width: 100%;
      margin-bottom: 30px;
      padding-right: 0 !important;
    }
    .contact-form { width: 100%; }

    .addresses .row { flex-direction: column; }
    .addresses .row .address { width: 60%; }
  }
</style>
